"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.StripePaymentStatus = exports.CompanyTypes = exports.CompanyVerificationStatus = exports.CompanyStatus = void 0;
var CompanyStatus;
(function (CompanyStatus) {
    CompanyStatus["ACTIVE"] = "active";
    CompanyStatus["BANNED"] = "banned";
    CompanyStatus["DELETED"] = "deleted";
    /** Company is terminated . Status can be changed only via Admin panel */
    CompanyStatus["TERMINATED"] = "terminated";
})(CompanyStatus = exports.CompanyStatus || (exports.CompanyStatus = {}));
var CompanyVerificationStatus;
(function (CompanyVerificationStatus) {
    CompanyVerificationStatus["PENDING_VERIFICATION"] = "pending_verification";
    CompanyVerificationStatus["REJECTED_WITH_RETRY_ALLOWED"] = "rejected_with_retry_allowed";
    CompanyVerificationStatus["STARTED_VERIFICATION"] = "started_verification";
    CompanyVerificationStatus["MANUAL_REVIEW_REQUIRED"] = "manual_review_required";
    CompanyVerificationStatus["REJECTED"] = "rejected";
    CompanyVerificationStatus["VERIFIED"] = "verified";
    /** Final rejected status can be only assigned via Admin panel */
    CompanyVerificationStatus["FINAL_REJECTED"] = "final_rejected";
})(CompanyVerificationStatus = exports.CompanyVerificationStatus || (exports.CompanyVerificationStatus = {}));
var CompanyTypes;
(function (CompanyTypes) {
    CompanyTypes["SOLE_TRADER"] = "sole_trader";
    CompanyTypes["COMPANY"] = "company";
})(CompanyTypes = exports.CompanyTypes || (exports.CompanyTypes = {}));
var StripePaymentStatus;
(function (StripePaymentStatus) {
    StripePaymentStatus["REQUESTED"] = "requested";
    StripePaymentStatus["ENABLED"] = "enabled";
    StripePaymentStatus["DISABLED"] = "disabled";
})(StripePaymentStatus = exports.StripePaymentStatus || (exports.StripePaymentStatus = {}));
